import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";

import { Alert } from "@components/base";

const DataOutdatedBanner: FC = () => {
  const { t } = useTranslation();

  return (
    <Box my={2}>
      <Alert severity="info">
        {t("csob.datasetComparison.dataOutdatedBanner.text")}
      </Alert>
    </Box>
  );
};

export default DataOutdatedBanner;
